import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'luci-badges',
  templateUrl: './luci-badges.component.html',
  styleUrls: ['./luci-badges.component.scss']
})
export class LuciBadgesComponent implements OnInit {

  @Input() badgeValue = '';
  @Input() background = '';

  @Output() clickCallBack = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

}
